import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        // Outside the guard on purpose: this is what a printed QR code points at,
        // and the people scanning it have no Spectrum login.
        path: 'verify/:token',
        loadComponent: () => import('./screens/verify/verify.component').then(m => m.VerifyComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () => import('./screens/dashboard/dashboard.component')
                    .then(m => m.DashboardComponent)
            },
            {
                path: 'issue',
                loadComponent: () => import('./screens/issue/issue.component').then(m => m.IssueComponent)
            },
            {
                path: 'register',
                loadComponent: () => import('./screens/register/register.component')
                    .then(m => m.RegisterComponent)
            },
            {
                path: 'templates',
                loadComponent: () => import('./screens/templates/templates.component')
                    .then(m => m.TemplatesComponent)
            },
            {
                path: 'templates/:id',
                loadComponent: () => import('./screens/studio/studio.component').then(m => m.StudioComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./screens/settings/settings.component')
                    .then(m => m.SettingsComponent),
                children: [
                    { path: '', redirectTo: 'numbering', pathMatch: 'full' },
                    {
                        path: 'numbering',
                        loadComponent: () => import('./screens/settings/numbering/numbering.component')
                            .then(m => m.NumberingComponent)
                    },
                    {
                        path: 'branding',
                        loadComponent: () => import('./screens/settings/branding/branding.component')
                            .then(m => m.BrandingComponent)
                    },
                    {
                        path: 'categories',
                        loadComponent: () => import('./screens/settings/categories/categories.component')
                            .then(m => m.CategoriesComponent)
                    }
                ]
            }
        ]
    },
    { path: '**', redirectTo: 'dashboard' }
];
